import consoleEvents from '../../consoleEvents';
import { IS_CLIENT } from '../../constants';
import { getLocale } from '../../locale';
import NextLocaleHelper from '../NextLocaleHelper';
import sessionStorage from './clientStorage';
var LabelStorageKey;
(function (LabelStorageKey) {
    LabelStorageKey["HYBRIS"] = "labels.hybris.";
    LabelStorageKey["AEM"] = "labels_aem_";
    LabelStorageKey["LSL"] = "labels_lsl_{name}_";
})(LabelStorageKey || (LabelStorageKey = {}));
const getLabelsByStorageKey = (storageKey, locale, file) => {
    const currentLocale = (IS_CLIENT ? locale : NextLocaleHelper.locale) || getLocale();
    if (currentLocale && storageKey) {
        const key = file ? `${storageKey}${currentLocale}_${file}` : `${storageKey}${currentLocale}`;
        try {
            const labelsInStorage = sessionStorage.getItem(key);
            if (labelsInStorage) {
                return JSON.parse(labelsInStorage);
            }
        }
        catch (error) {
            consoleEvents.error(`Get labels of ${key} from storage`, error);
        }
    }
    return undefined;
};
const getStoredHybrisLabels = (locale) => getLabelsByStorageKey(LabelStorageKey.HYBRIS, locale);
const getStoredAemLabels = (locale) => getLabelsByStorageKey(LabelStorageKey.AEM, locale);
const getStoredLslLabels = (name, locale, file) => getLabelsByStorageKey(LabelStorageKey.LSL.replace('{name}', name), locale, file);
export { LabelStorageKey, getStoredAemLabels, getStoredHybrisLabels, getStoredLslLabels };
//# sourceMappingURL=getLabelsByStorageKey.js.map